function articleItem(to, articleKey) {
  return {
    to,
    articleKey,
  };
}

/**
 * Routes /articles exposées dans le menu public. `articleKey` → clés `common.json` (`articles.*`).
 * Les briefs editoriaux qualitatifs sont valides au build dans `scripts/validate-article-editorial.cjs`.
 */
export const ARTICLE_MENU_GROUPS = [
  {
    groupKey: 'secteurs',
    items: [
      articleItem('/secteurs/', 'secteurs_hub'),
      articleItem('/secteurs/conciergerie/', 'hub_conciergerie'),
      articleItem('/secteurs/gestion-locative/', 'hub_gestion_locative'),
      articleItem('/secteurs/camping/', 'hub_camping'),
      articleItem('/secteurs/hotellerie/', 'hub_hotellerie'),
      articleItem('/secteurs/btp/', 'hub_btp'),
      articleItem('/secteurs/artisans/', 'hub_artisans'),
      articleItem('/secteurs/maintenance-industrielle/', 'hub_maintenance_industrielle'),
      articleItem('/secteurs/location-materiel/', 'hub_location_materiel'),
      articleItem('/secteurs/location-velo/', 'hub_location_velo'),
      articleItem('/secteurs/sav-electromenager/', 'hub_sav_electromenager'),
      articleItem('/secteurs/facility-management/', 'hub_facility_management'),
      articleItem('/secteurs/climatisation/', 'hub_climatisation'),
      articleItem('/secteurs/energie-solaire/', 'hub_energie_solaire'),
      articleItem('/secteurs/borne-irve/', 'hub_borne_irve'),
      articleItem('/secteurs/securite-electronique/', 'hub_securite_electronique'),
      articleItem('/secteurs/videosurveillance/', 'hub_videosurveillance'),
      articleItem('/secteurs/telesurveillance/', 'hub_telesurveillance'),
      articleItem('/secteurs/ascensoristes/', 'hub_ascensoristes'),
      articleItem('/secteurs/sav-medical/', 'hub_sav_medical'),
      articleItem('/secteurs/syndic-copropriete/', 'hub_syndic_copropriete'),
      articleItem('/secteurs/immobilier/', 'hub_immobilier'),
    ],
  },
  {
    groupKey: 'comparatifs',
    items: [
      articleItem('/comparatifs/', 'comparatifs_hub'),
      articleItem('/comparatifs/whatsapp-vs-assistance-video-sav/', 'comparatif_whatsapp'),
      articleItem('/comparatifs/telephone-vs-diagnostic-video/', 'comparatif_telephone'),
      articleItem('/comparatifs/facetime-vs-assistance-video/', 'comparatif_facetime'),
      articleItem('/comparatifs/teamviewer-vs-assistance-video-terrain/', 'comparatif_teamviewer'),
      articleItem('/comparatifs/visioconference-vs-visio-assistance-metier/', 'comparatif_visioconference'),
      articleItem('/comparatifs/application-vs-lien-navigateur/', 'comparatif_application_navigateur'),
      articleItem('/comparatifs/solutions-assistance-video/', 'comparatif_solutions_assistance_video'),
    ],
  },
  {
    groupKey: 'guide',
    items: [
      articleItem('/guides/', 'guides_hub'),
      articleItem('/assistance-video/', 'definition_usages_avantages'),
      articleItem('/visio-assistance/', 'visio_assistance_pillar'),
      articleItem('/teleassistance/', 'teleassistance_metier'),
      articleItem('/support-client-video/', 'support_client_video'),
      articleItem('/articles/assistance-video-rgpd-precautions-support-client-distance', 'assistance_video_rgpd'),
      articleItem('/articles/envoyer-lien-video-client-voir-probleme', 'envoyer_lien'),
      articleItem('/articles/voir-ce-que-voit-client-smartphone-assistance-video', 'voir_ce_que_voit_client'),
      articleItem('/diagnostic-video-distance/', 'diagnostic_visuel_distance'),
      articleItem('/guides/methodologie-diagnostic-visuel/', 'guide_methodologie_diagnostic'),
    ],
  },
  {
    groupKey: 'ressources',
    items: [
      articleItem('/a-propos/', 'a_propos_hub'),
      articleItem('/cas-clients/', 'cas_clients_hub'),
      articleItem('/roi/', 'roi_hub'),
      articleItem('/faq/', 'faq_hub'),
      articleItem('/glossaire/', 'glossaire_hub'),
      articleItem('/roi/methodologie-calcul/', 'roi_methodologie'),
      articleItem('/roi/reduire-deplacements-techniciens/', 'roi_reduire_deplacements'),
      articleItem('/roi/calculateur/', 'roi_calculateur'),
      articleItem('/a-propos/chiffres/', 'chiffres_produit'),
      articleItem('/cas-clients/conciergerie/', 'cas_client_conciergerie'),
      articleItem('/cas-clients/camping/', 'cas_client_camping'),
      articleItem('/cas-clients/btp/', 'cas_client_btp'),
    ],
  },
  {
    groupKey: 'multiservices',
    items: [
      articleItem('/articles/assistance-video-artisans-qualifier-demande-avant-deplacement', 'artisans_qualifier'),
      articleItem('/articles/assistance-video-artisans-pre-diagnostic-video-avant-devis', 'artisans_pre_diag'),
      articleItem('/articles/assistance-video-artisans-gagner-temps-petits-depannages', 'artisans_gagner_temps'),
      articleItem('/articles/assistance-video-artisans-eviter-deplacements-inutiles', 'artisans_eviter_deplacements'),
      articleItem('/articles/assistance-video-reparateurs-diagnostiquer-panne-avant-prise-en-charge', 'reparateurs_diag'),
      articleItem('/sav-video/', 'assistance_video_sav'),
      articleItem('/articles/assistance-video-depanneur-diagnostiquer-avant-intervention', 'depanneurs_diag'),
      articleItem('/articles/depannage-video-distance-quand-possible', 'depannage_video_distance'),
      articleItem('/articles/reduire-interventions-inutiles-entreprise-depannage', 'depannage_reduire_interventions'),
      articleItem('/articles/assistance-video-plombier-voir-fuite-avant-deplacement', 'plombiers_fuite'),
      articleItem('/articles/assistance-video-electricien-diagnostiquer-probleme-distance', 'electriciens_diag'),
    ],
  },
  {
    groupKey: 'b2b',
    items: [
      articleItem('/articles/assistance-video-artisan-depanner-conseiller-qualifier-demande-client', 'artisan_video'),
    ],
  },
  {
    groupKey: 'industrie',
    items: [
      articleItem('/articles/visio-assistance-maintenance-industrielle-reduire-arrets-machine', 'maintenance_industrielle'),
      articleItem(
        '/articles/machine-industrielle-arret-diagnostiquer-distance',
        'machine_industrielle_arret'
      ),
      articleItem(
        '/articles/reduire-deplacements-techniciens-maintenance-assistance-video',
        'reduire_deplacements_techniciens_maintenance'
      ),
    ],
  },
  {
    groupKey: 'btp',
    items: [
      articleItem('/articles/assistance-video-btp-suivre-diagnostiquer-depanner-distance', 'assistance_video_btp'),
      articleItem('/articles/assistance-video-materiel-chantier-loue-guider-client-temps-reel', 'materiel_chantier'),
      articleItem('/articles/video-visio-assistance-chantier-guider-equipe-terrain-distance', 'visio_assistance_chantier'),
      articleItem('/articles/reduire-deplacements-chantier-assistance-video', 'reduire_deplacements_chantier'),
      articleItem('/articles/diagnostic-video-avant-devis-travaux-qualifier-demande-client', 'diagnostic_video_devis_travaux'),
      articleItem('/articles/controle-qualite-chantier-video-distance', 'controle_qualite_chantier'),
    ],
  },
  {
    groupKey: 'concierge',
    items: [
      articleItem('/articles/conciergerie-assistance-video-distancielle', 'concierge_dist'),
      articleItem(
        '/articles/conciergerie-depannage-voyageur-distance-serrure-wifi-chauffage-electromenager',
        'concierge_depannage_voyageur'
      ),
      articleItem(
        '/articles/conciergerie-assistance-video-check-in-autonome-boite-cles-digicode-serrure-connectee',
        'concierge_checkin'
      ),
      articleItem(
        '/articles/conciergerie-assistance-video-voyageurs-moins-interventions-physiques',
        'concierge_moins_physique'
      ),
      articleItem('/articles/etat-des-lieux-video-a-distance-location-courte-duree', 'etat_des_lieux_video'),
      articleItem(
        '/articles/conciergerie-assistance-video-reduire-deplacements-rentabilite-operationnelle',
        'concierge_rentabilite'
      ),
      articleItem('/articles/conciergerie-qualifier-panne-location-courte-duree-faux-deplacements', 'concierge_qualifier_panne'),
      articleItem('/articles/assistance-video-loueur-materiel-depanner-clients-distance', 'loueur_materiel'),
      articleItem('/articles/diagnostiquer-panne-materiel-loue-distance', 'panne_materiel_loue'),
      articleItem('/articles/depannage-distance-location-materiel-eviter-retours-inutiles', 'depannage_location_materiel'),
      articleItem('/articles/reduire-couts-sav-location-materiel-assistance-video', 'reduire_couts_sav_location_materiel'),
      articleItem('/articles/assistance-video-loueur-velos-distance', 'loueur_velos'),
      articleItem('/articles/depannage-velo-loue-distance-video-freins-chaine-batterie', 'depannage_velo_loue'),
    ],
  },
  {
    groupKey: 'camping',
    items: [
      articleItem('/articles/depannage-mobil-home-client-distance', 'mobil_home_depannage'),
      articleItem('/articles/camping-mobil-home-aider-vacancier-utiliser-equipements', 'camping_mobil_equip'),
      articleItem(
        '/articles/assistance-video-camping-reception-maintenance-confort-vacanciers',
        'camping_video_reception_maintenance'
      ),
      articleItem('/articles/camping-assistance-video-reduire-deplacements-personnel-technique', 'camping_moins_trajets'),
      articleItem('/articles/camping-petits-incidents-clients-lien-video', 'camping_petits_incidents'),
      articleItem('/articles/camping-assistance-video-aider-vacanciers-sans-deplacement', 'camping_aide_sans_depl'),
      articleItem('/articles/camping-visio-assistance-experience-client-haute-saison', 'camping_visio_sat'),
      articleItem('/articles/assistance-video-hotel-sans-mobiliser-reception', 'hotel_reception'),
      articleItem('/articles/depannage-client-hotel-distance-reception-tv-clim-coffre', 'depannage_client_hotel'),
      articleItem('/articles/reduire-appels-reception-hotel-assistance-video', 'appels_reception_hotel'),
      articleItem('/articles/assistance-video-hotel-independant-service-client-reactif', 'hotel_independant'),
    ],
  },
];
